import React from "react";
import { Select } from "antd";

const { Option } = Select;

const CountryCodeDropdown = ({
  defaultValue,
  placeholder,
  options,
  onChange,
  onAddNew,
  optionFilterProp = "children",
  width = 50,
  borderColor = "#ccc",
  newItemLabel = "+ Add New",
  theme = { colors: { bordertask: "#ccc" } },
}) => {
  return (
    <Select
      showSearch
      value={defaultValue || undefined}
      onChange={onChange}
      style={{
        width: `${width}px`,
        borderRadius: "3px",
        height: "27px",
        padding: "0px !important",
      }}
      placeholder={placeholder}
      optionFilterProp={optionFilterProp}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      {options.map((option) => (
        <Option
          key={option.id}
          value={option.id}
          style={{
            borderTop: `1px solid ${theme.colors.bordertask}`,
            borderRadius: "0px",
          }}
        >
          {option.code}
        </Option>
      ))}
    </Select>
  );
};

export default CountryCodeDropdown;
